import {stateData, reduxState} from '../../values';

const initialState = {
    faqs:         [],
    status:         stateData.state1,
    faqsEdit:     [],
    records:        1
};

const reducer = (state=initialState, action) =>{
    if(action.type === reduxState.get_faqs){
        return {
            ...state,
            faqs:     action.payload,
            status:     action.status,
            records:    action.records
        }
    }
    if(action.type === reduxState.update_faqs){
        return {
            ...state,
            faqsEdit: action.payload
        }
    }
    return state
}
export default reducer